import { proxyMetrics, paymentsRequests, stripeRequests, braintreeRequests } from '@/new_api/instances'
import POSTBACK from '@/new_api/services/proxyMetrics'
import PAYMENTS from '@/new_api/services/payments'
import STRIPE from '@/new_api/services/stripe'
import BRAINTREE from '@/new_api/services/braintree'
export const API = {
  POSTBACK: POSTBACK(proxyMetrics),
  PAYMENTS: PAYMENTS(paymentsRequests),
  STRIPE: STRIPE(stripeRequests),
  BRAINTREE: BRAINTREE(braintreeRequests)
}
